import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './EnhancedComponents.css';

const ThanksgivingVideos = () => {
  const navigate = useNavigate();
  const [playingVideo, setPlayingVideo] = useState(null);

  // Thanksgiving video data from the original HTML (ordered oldest to newest)
  const thanksgivingVideos = [
    {
      year: 2012,
      artist: 'PSY',
      song: 'Gangnam Style',
      youtubeId: 'LAF2VIG1S7g'
    },
    {
      year: 2013,
      artist: 'The Wanted',
      song: 'Glad You Came',
      youtubeId: 'XmIk63OGbLk'
    },
    {
      year: 2014,
      artist: 'Meghan Trainor',
      song: 'All About That Bass',
      youtubeId: 'TRCJumqM_no'
    },
    {
      year: 2015,
      artist: 'Macklemore & Ryan Lewis (feat. Eric Nally, Melle Mel, Kool Moe Dee & Grandmaster Caz)',
      song: 'Downtown',
      youtubeId: 'K3DbJcSAvEQ'
    },
    {
      year: 2016,
      artist: 'Rae Sremmurd (feat. Gucci Mane)',
      song: 'Black Beatles',
      youtubeId: 'GOxFykQrvPY'
    },
    {
      year: 2017,
      artist: 'Taylor Swift',
      song: 'Look What You Made Me Do',
      youtubeId: 'JBiXyDco24A'
    },
    {
      year: 2018,
      artist: 'Cardi B, Bad Bunny & J Balvin',
      song: 'I Like It',
      youtubeId: 'YhGbQt7ewuQ'
    },
    {
      year: 2019,
      artist: 'Lizzo',
      song: 'Truth Hurts',
      youtubeId: 'Rw0Cx1Cml7s'
    }
  ];

  const handlePlayVideo = (videoId) => {
    setPlayingVideo(videoId);
  };

  const handleCloseVideo = () => {
    setPlayingVideo(null);
  };

  const handleBackToPane = () => {
    navigate('/recipes');
  };

  return (
    <section id="thanksgiving" className="section thanksgiving-section">
      <div className="section-header">
        <img src="/images/pane.png" alt="Thanksgiving" className="section-icon" />
        <h1>Thanksgiving Family Tradition</h1>
      </div>

      <div className="thanksgiving-content">
        <p className="welcome-text">
          Every year, our family gathers for Thanksgiving and celebrates with music that defined each year. 
          Here's our collection of memorable songs that became the soundtrack to our family celebrations.
        </p>

        <div className="thanksgiving-stats">
          <div className="stat-item">
            <strong>Years of Tradition:</strong> {thanksgivingVideos.length}
          </div>
          <div className="stat-item">
            <strong>First Year:</strong> 2012
          </div>
          <div className="stat-item">
            <strong>Latest Year:</strong> 2019
          </div>
        </div>

        {/* Back Button */}
        <div className="thanksgiving-controls">
          <button className="cta-btn secondary" onClick={handleBackToPane}>
            <i className="fas fa-arrow-left"></i>
            Back to Recipes
          </button>
        </div>
      </div>

      {/* Video Grid */}
      <div className="video-grid">
        {thanksgivingVideos.map((video) => (
          <div key={video.year} className="video-card">
            <div className="video-year">{video.year}</div>
            <div className="video-thumbnail" onClick={() => handlePlayVideo(video.youtubeId)}>
              <img 
                src={`https://img.youtube.com/vi/${video.youtubeId}/hqdefault.jpg`}
                alt={`${video.song} by ${video.artist}`}
                className="thumbnail-image"
                onError={(e) => {
                  // Fallback to medium quality if high quality fails
                  e.target.src = `https://img.youtube.com/vi/${video.youtubeId}/mqdefault.jpg`;
                }}
              />
              <div className="play-overlay">
                <i className="fas fa-play-circle"></i>
              </div>
            </div>
            <div className="video-info">
              <h3 className="video-title">{video.song}</h3>
              <p className="video-artist">{video.artist}</p>
            </div>
            <div className="video-actions">
              <button 
                className="cta-btn primary small"
                onClick={() => handlePlayVideo(video.youtubeId)}
              >
                <i className="fas fa-play"></i>
                Watch
              </button>
              <a 
                href={`https://www.youtube.com/watch?v=${video.youtubeId}`}
                target="_blank"
                rel="noopener noreferrer"
                className="cta-btn secondary small"
              >
                <i className="fab fa-youtube"></i>
                YouTube
              </a>
            </div>
          </div>
        ))}
      </div>

      {/* TV-Style Video Modal - Large Size Version */}
      {playingVideo && (
        <div className="video-modal video-modal-v2" onClick={handleCloseVideo}>
          <div className="tv-container tv-container-large" onClick={(e) => e.stopPropagation()}>
            <div className="tv-frame tv-frame-large">
              <div className="tv-screen tv-screen-large">
                <div className="video-wrapper video-wrapper-large">
                  <iframe
                    src={`https://www.youtube.com/embed/${playingVideo}?autoplay=1`}
                    title="Thanksgiving Video"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
              <div className="tv-controls">
                <div className="tv-brand">FAMILY TV</div>
                <div className="tv-buttons">
                  <div className="tv-button power" onClick={handleCloseVideo} title="Power Off">
                    <i className="fas fa-power-off"></i>
                  </div>
                  <div className="tv-button volume">
                    <i className="fas fa-volume-up"></i>
                  </div>
                  <div className="tv-button channel">
                    <i className="fas fa-tv"></i>
                  </div>
                </div>
              </div>
              <div className="tv-stand"></div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default ThanksgivingVideos;